import { useCallback } from 'react';

export const useFormHandlers = (
    setDescribeFormData: React.Dispatch<React.SetStateAction<any>>,
    setContactFormData: React.Dispatch<React.SetStateAction<any>>
) => {
    const handleDescribeFormDataChange = useCallback((name: string, value: string) => {
        setDescribeFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }, [setDescribeFormData]);

    const handleContactFormDataChange = useCallback((name: string, value: string | boolean) => {
        setContactFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }, [setContactFormData]);

    return {
        handleDescribeFormDataChange,
        handleContactFormDataChange
    };
};
